import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Url } from "../url/url";

const S = `
  .spl-wrap{background:#f1f5f9;min-height:100vh;padding:24px 20px}
  .spl-card{background:#fff;border-radius:12px;box-shadow:0 2px 10px rgba(0,0,0,.07);overflow:hidden;max-width:1100px}
  .spl-th{background:#1a2b4a;color:#fff;padding:12px 16px;text-align:left;font-size:12px;font-weight:600;white-space:nowrap}
  .spl-td{padding:12px 16px;font-size:13px;border-bottom:1px solid #f3f4f6;vertical-align:middle}
  tr:last-child .spl-td{border-bottom:none}
  tr:hover .spl-td{background:#f8faff}
  .spl-badge-on{padding:3px 12px;border-radius:20px;background:#22c55e;color:#fff;font-size:11px;font-weight:700;cursor:pointer;border:none}
  .spl-badge-off{padding:3px 12px;border-radius:20px;background:#ef4444;color:#fff;font-size:11px;font-weight:700;cursor:pointer;border:none}
  .spl-edit-btn{padding:5px 12px;border-radius:6px;border:1px solid #4f46e5;background:#fff;
    color:#4f46e5;cursor:pointer;font-size:12px;font-weight:600;transition:all .15s;white-space:nowrap}
  .spl-edit-btn:hover{background:#4f46e5;color:#fff}
  .spl-del-btn{padding:5px 9px;border-radius:6px;border:1px solid #fecaca;background:#fff;
    color:#ef4444;cursor:pointer;font-size:13px;transition:all .15s}
  .spl-del-btn:hover{background:#fee2e2}
  .spl-btn-add{background:#4f46e5;color:#fff;border:none;border-radius:7px;padding:8px 18px;
    font-weight:600;cursor:pointer;font-size:13px;display:inline-flex;align-items:center;gap:6px;transition:background .2s}
  .spl-btn-add:hover{background:#4338ca}
  @keyframes splIn{from{transform:translateX(50px);opacity:0}to{transform:translateX(0);opacity:1}}
  .spl-toast{position:fixed;top:20px;right:20px;z-index:9999;padding:12px 18px;border-radius:9px;
    color:#fff;font-weight:600;font-size:14px;display:flex;align-items:center;gap:10px;
    min-width:260px;box-shadow:0 8px 24px rgba(0,0,0,.18);animation:splIn .2s ease}
  .spl-modal-bg{position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9998;
    display:flex;align-items:center;justify-content:center}
  .spl-modal{background:#fff;border-radius:14px;padding:30px;max-width:380px;width:90%;
    box-shadow:0 20px 50px rgba(0,0,0,.2);text-align:center}
`;

export default function StaticPagesList() {
  const navigate   = useNavigate();
  const [pages,    setPages]    = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [deleteId, setDeleteId] = useState(null);
  const [toast,    setToast]    = useState(null);

  const showToast = useCallback((msg, ok = true) => {
    setToast({ msg, ok });
    setTimeout(() => setToast(null), 3200);
  }, []);

  const fetchPages = useCallback(() => {
    setLoading(true);
    axios.get(`${Url}/api/staticpage`)
      .then(r => setPages(r.data.data || []))
      .catch(() => showToast("Pages load nahi hue", false))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { fetchPages(); }, [fetchPages]);

  const handleToggle = async pid => {
    try {
      await axios.patch(`${Url}/api/staticpage/${pid}/toggle`, {});
      fetchPages();
    } catch { showToast("Toggle error", false); }
  };

  const handleDelete = async () => {
    if (!deleteId) return;
    try {
      await axios.delete(`${Url}/api/staticpage/${deleteId}`);
      showToast("Page delete ho gayi 🗑️");
      fetchPages();
      setDeleteId(null);
    } catch { showToast("Delete error", false); }
  };

  return (
    <div className="spl-wrap">
      <style>{S}</style>

      {/* Toast */}
      {toast && (
        <div className="spl-toast" style={{ background: toast.ok ? "#22c55e" : "#ef4444" }}>
          {toast.ok ? "✅" : "❌"} {toast.msg}
          <button type="button" onClick={() => setToast(null)}
            style={{ marginLeft:"auto",background:"none",border:"none",color:"#fff",cursor:"pointer",fontSize:18 }}>×</button>
        </div>
      )}

      {/* Delete Modal */}
      {deleteId && (
        <div className="spl-modal-bg" role="dialog" aria-modal="true">
          <div className="spl-modal">
            <div style={{ fontSize:44,marginBottom:10 }}>🗑️</div>
            <h5 style={{ fontWeight:700,marginBottom:8 }}>Page Delete Karo?</h5>
            <p style={{ color:"#6b7280",marginBottom:22 }}>Yeh action undo nahi ho sakta.</p>
            <div style={{ display:"flex",gap:10 }}>
              <button type="button" onClick={() => setDeleteId(null)}
                style={{ flex:1,padding:"10px",borderRadius:7,border:"1px solid #d1d5db",background:"#fff",cursor:"pointer",fontWeight:600 }}>
                Cancel
              </button>
              <button type="button" onClick={handleDelete}
                style={{ flex:1,padding:"10px",borderRadius:7,border:"none",background:"#ef4444",color:"#fff",cursor:"pointer",fontWeight:600 }}>
                Delete Karo
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Card */}
      <div className="spl-card">

        {/* Header */}
        <div style={{ padding:"16px 20px",borderBottom:"1px solid #f3f4f6",
          display:"flex",justifyContent:"space-between",alignItems:"center" }}>
          <h5 style={{ margin:0,fontWeight:700,fontSize:16 }}>📄 All Static Pages</h5>
          <button type="button" className="spl-btn-add"
            onClick={() => navigate("/dashboard/StaticPageCreate")}>
            + Add New Page
          </button>
        </div>

        {/* Table */}
        {loading ? (
          <div style={{ textAlign:"center",padding:"60px 0" }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : pages.length === 0 ? (
          <div style={{ textAlign:"center",padding:"60px 20px",color:"#9ca3af" }}>
            <div style={{ fontSize:48,marginBottom:10 }}>📄</div>
            <p style={{ margin:0,fontSize:15 }}>Koi static page nahi hai abhi</p>
            <button type="button" className="spl-btn-add"
              onClick={() => navigate("/dashboard/StaticPages")}
              style={{ marginTop:16 }}>
              Pehla Page Banao
            </button>
          </div>
        ) : (
          <div style={{ overflowX:"auto" }}>
            <table style={{ width:"100%",borderCollapse:"collapse" }}>
              <thead>
                <tr>
                  {["#","Status","Title","Slug","Created","Actions"].map(h => (
                    <th key={h} className="spl-th">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {pages.map((page, i) => (
                  <tr key={page._id}>
                    <td className="spl-td" style={{ color:"#9ca3af",fontWeight:600,width:40 }}>
                      {i + 1}
                    </td>
                    <td className="spl-td" style={{ width:100 }}>
                      <button type="button"
                        className={page.isActive ? "spl-badge-on" : "spl-badge-off"}
                        onClick={() => handleToggle(page._id)}>
                        {page.isActive ? "active" : "inactive"}
                      </button>
                    </td>
                    <td className="spl-td"
                      style={{ fontWeight:600,maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap" }}>
                      {page.title}
                    </td>
                    <td className="spl-td">
                      <code style={{ fontSize:12,color:"#6b7280",background:"#f3f4f6",padding:"2px 8px",borderRadius:4 }}>
                        {page.slug}
                      </code>
                    </td>
                    <td className="spl-td" style={{ color:"#9ca3af",fontSize:12,whiteSpace:"nowrap" }}>
                      {new Date(page.createdAt).toLocaleDateString('en-IN', {
                        day:'2-digit', month:'short', year:'numeric'
                      })}
                    </td>
                    <td className="spl-td">
                      <div style={{ display:"flex",gap:6,alignItems:"center" }}>
                        <button type="button" className="spl-edit-btn"
                          onClick={() => navigate(`/dashboard/StaticPages/edit/${page._id}`)}>
                          ✏️ Edit
                        </button>
                        <button type="button" className="spl-del-btn"
                          onClick={() => setDeleteId(page._id)} aria-label="Delete">
                          🗑️
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}